import React, { useState, useCallback } from 'react';
import { Department, DepartmentManager } from '../components/Automation/Department/DepartmentManager';
import { ProgramsList } from '../components/Automation/Department/ProgramsList';
import BusinessIcon from '@mui/icons-material/Business';

interface DepartmentsPageProps {
    onLogout: () => void;
    username: string;
    role: string;
}

const DepartmentsPage: React.FC<DepartmentsPageProps> = ({ onLogout, username, role }) => {
    const [departments, setDepartments] = useState<Department[]>([]);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const handleDepartmentsLoad = useCallback((loadedDepartments: Department[]) => {
        setDepartments(loadedDepartments);
    }, []);

    const forceRefresh = useCallback(() => {
        setRefreshTrigger(prev => prev + 1);
    }, []);

    return (
        <div className="w-full">
            <div className="p-4 lg:p-8 space-y-8">
                <h1 className="text-2xl font-semibold text-gray-800 flex items-center gap-3">
                    <BusinessIcon fontSize='large' className="text-blue-600"/>
                    Управление отделами и программами
                </h1>
                <DepartmentManager onLoad={handleDepartmentsLoad} refreshTrigger={refreshTrigger} onRefresh={forceRefresh} />
                <ProgramsList departments={departments} refreshTrigger={refreshTrigger} onRefresh={forceRefresh} />
            </div>
        </div>
    );
};

export default DepartmentsPage;